import { IconButton } from "@components/button";
import { IFocusableItemProps } from "@components/focusManager";
import { StatusYesIcon } from "@components/icon";
import {
    CaretIconRight,
    CaretWrapper,
    Circle,
    IconWrapper,
    TaskRowStyled,
    TaskRowWrapper
} from "@pages/fiscalYearClose/FiscalYearClose.styles";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { IconSize } from "../../enums";
import { KeyName } from "../../keyName";
import TestIds from "../../testIds";

interface IProps {
    taskId: string;
    title: string;
    onTaskSelect: (id: string) => void;
    isChecked: boolean;
    isSelected: boolean;
    isClosed: boolean;
    isDisabled: boolean;
    isStep: boolean;
    itemProps: IFocusableItemProps;
}

export const SplitPageWizardRow: React.FC<IProps> = ({
                                                         taskId,
                                                         onTaskSelect,
                                                         isChecked,
                                                         isSelected,
                                                         isClosed,
                                                         isDisabled,
                                                         isStep,
                                                         itemProps,
                                                         title
                                                     }) => {
    const { t } = useTranslation("Common");
    const handleClick = useCallback((): void => {
        if (isDisabled) {
            return;
        }
        onTaskSelect(taskId);
    }, [taskId, isDisabled, onTaskSelect]);

    const handleKeyDown = useCallback((event: React.KeyboardEvent): void => {
        if (isDisabled) {
            return;
        }
        if (event.key === KeyName.Enter) {
            onTaskSelect(taskId);
        }
    }, [taskId, isDisabled, onTaskSelect]);

    function getCaretIcon(): React.ReactElement {
        return <CaretWrapper onClick={handleClick} data-testid={TestIds.TaskRowCaret}>
            <IconButton
                    tabIndex={-1}
                    isDecorative
                    title={t("Common:General.Open")}>
                <CaretIconRight height={IconSize.M} width={IconSize.M}/>
            </IconButton>
        </CaretWrapper>;
    }

    if (!isStep) {
        return <TaskRowWrapper isSelected={isSelected} data-testid={TestIds.TaskRow}>
            <TaskRowStyled
                {...itemProps}
                onClick={handleClick}
                onKeyDown={handleKeyDown}
                isSelected={isSelected}
                isClosing={true}
                isChecked={isChecked}
                data-testid={TestIds.TaskRowContent}>
                <IconWrapper data-testid={TestIds.TaskRowStatusIcon}>
                    {isChecked ? <StatusYesIcon width={IconSize.M} height={IconSize.M}/> : <Circle/>}
                </IconWrapper>
                {title}
            </TaskRowStyled>
            {getCaretIcon()}
        </TaskRowWrapper>;
    }

    return (<TaskRowWrapper isSelected={isSelected} data-testid={TestIds.TaskRow} isDisabled={isDisabled}>
        <IconWrapper data-testid={TestIds.TaskRowStatusIcon}>
            {isChecked ? <StatusYesIcon width={IconSize.M} height={IconSize.M}/> : <Circle/>}
        </IconWrapper>
        <TaskRowStyled
                {...itemProps}
                onClick={handleClick}
                onKeyDown={handleKeyDown}
                isSelected={isSelected}
                isChecked={isChecked}
                data-testid={TestIds.TaskRowContent}>
            {title}
        </TaskRowStyled>
        {getCaretIcon()}
    </TaskRowWrapper>);
};
